module.exports = __webpack_public_path__ + "img/1 (115).eea5426b.png";